import React from 'react';
import PropTypes from 'prop-types';
import './ColoredCheckbox.scss';

const ColoredCheckbox = ({ label, color, checked, disabled, name, onChange }) => {
  return (
    <div className={`colored-checkbox ${color}`}>
      <label>
        <input
          type="checkbox"
          name={name}
          checked={checked}
          disabled={disabled}
          onChange={onChange}
        />
        <span className="checkbox-label">{label}</span>
      </label>
    </div>
  );
};

ColoredCheckbox.propTypes = {
  label: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

ColoredCheckbox.defaultProps = {
  disabled: false,
};

export default ColoredCheckbox;
